import { Container, Typography } from "@mui/material";
import { Grid, Box, Button } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Paper from "@mui/material/Paper";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import { useStyles } from "./linegraph2-styles";
import { useTheme,alpha } from "@mui/material";
import React from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const data = [
  {
    name: "Page D",
    uv: 9780,
    pv: 3908,
    amt: 2000,
  },
  {
    name: "Page E",
    uv: 9890,
    pv: 4800,
    amt: 2181,
  },

  {
    name: "Page B",
    uv: 3000,
    pv: 1398,
    amt: 2210,
  },
  {
    name: "Page C",
    uv: 9000,
    pv: 9800,
    amt: 2290,
  },
  {
    name: "Page D",
    uv: 27680,
    pv: 3908,
    amt: 2000,
  },
  {
    name: "Page E",
    uv: 1890,
    pv: 4800,
    amt: 2181,
  },
  {
    name: "Page F",
    uv: 2390,
    pv: 3800,
    amt: 2500,
  },
  {
    name: "Page G",
    uv: 34890,
    pv: 4300,
    amt: 2100,
  },
  {
    name: "Page B",
    uv: 30300,
    pv: 1398,
    amt: 2210,
  },
  {
    name: "Page F",
    uv: 23290,
    pv: 3800,
    amt: 2500,
  },
  {
    name: "Page G",
    uv: 34290,
    pv: 4300,
    amt: 24100,
  },

  {
    name: "Page C",
    uv: 20500,
    pv: 9800,
    amt: 2290,
  },
  {
    name: "Page D",
    uv: 2780,
    pv: 3908,
    amt: 2000,
  },
  {
    name: "Page E",
    uv: 1890,
    pv: 4800,
    amt: 12181,
  },
  {
    name: "Page F",
    uv: 23490,
    pv: 3800,
    amt: 2500,
  },

  {
    name: "Page F",
    uv: 2390,
    pv: 3800,
    amt: 22500,
  },
  {
    name: "Page G",
    uv: 34590,
    pv: 4300,
    amt: 2100,
  },
  {
    name: "Page G",
    uv: 34590,
    pv: 4300,
    amt: 24100,
  },
];

const BasicLineGraph = () => {
  const theme = useTheme();

  return (
    <ResponsiveContainer width="100%" height="100%">
      <AreaChart
        width={730}
        height={250}
        data={data}
        margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
      >
        <defs>
          <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
            <stop
              offset="5%"
              stopColor={theme.palette.primary.main}
              stopOpacity={0.8}
            />
            <stop
              offset="95%"
              stopColor={theme.palette.primary.main}
              stopOpacity={0}
            />
          </linearGradient>
        </defs>
        <XAxis tickLine={false} dataKey="name" axisLine    />
        <YAxis axisLine={false} tickLine={false}  hide />
        <CartesianGrid vertical={false} strokeWidth={theme.spacing(0.05)} />
        <Tooltip strokeDasharray="3 3" />
        <Area
          type="monotone"
          dataKey="uv"
          stroke={theme.palette.primary.main}
          strokeWidth={theme.spacing(0.5)}
          fillOpacity={1}
          fill="url(#colorUv)"
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};

export const LineGraph2Card = () => {
  const classes = useStyles();
  const theme = useTheme();
  return (
    <Paper className={classes.paper} variant="elevation" elevation={0}>
      <Box  className={classes.cardContentsWrapper}>
        <Box className={classes.cardTextArea}>
          <Typography variant="h6" className={classes.cardHeader}>
            Transaction
          </Typography>

          <Typography>5878 Suceessfull Transaction</Typography>

          <Box
            sx={{
              display: "flex",
            }}
          >
            <Typography variant="h6" className={classes.cardHeader}>
              $2,09,352k
            </Typography>
            <Typography className={classes.cardText}>
              <Avatar
                className={classes.avatarIcon}
                sx={{
                  backgroundColor: alpha(theme.palette.primary.main, 0.1),

                  color: theme.palette.primary.main,
                }}
              >
                <ShowChartIcon />
              </Avatar>
              86%
            </Typography>
          </Box>

          <Typography>Total Balance</Typography>
        </Box>

        <Box sx={{ height: theme.spacing(40) }}>
          <BasicLineGraph />
        </Box>
      </Box>
    </Paper>
  );
};
